import FirebaseService from './FirebaseService'
import { api } from './ApiService'
import moment from 'moment'
import Mask from '../constants/Mask'

export default class FinanceService extends FirebaseService {
    finance = async filial => {
        const data = await this.firebase.request('finances', filial)

        const values = data.items || data.result.items

        return values.map(v => ({
            ...v,
            value: Number(v.value),
            valueWithFare: Number(v.valueWithFare),
            canPagSeguro: v.canPagSeguro ? 1 : 0,
        }))
    }

    loginWithFinance = (hash, filial) =>
        this.firebase.request('loginWithFinance', filial, { hash })

    createInvoice = async (filial, idReceitas) => {
        const { success, result } = await this.firebase.request(
            'generateInvoice',
            filial,
            { idReceitas },
            true
        )
        if (!success || !result.endpoint) {
            return Promise.reject({ success: false })
        }

        return { success: true, endpoint: result.endpoint }
    }

    boleto = (finance, banco) =>
        api.post(`boleto/store/${banco}`, {
            documento: this.user.cpf,
            nome: this.user.nome,
            cep: this.user.cep,
            endereco: this.user.endereco,
            bairro: this.user.bairro,
            cidade: this.user.cidade,
            uf: this.user.estado,
            valor: finance.value,
            vencimento: moment(finance.dtVencto, Mask.BR_DATE).format(
                Mask.SQL_DATE_MASK
            ),
            matricula: this.user.matricula,
            codeFilial: this.user.codeFilial,
            idReceita: finance.idReceita,
            nossoNumero: finance.nossoNumero,
            service: finance.service,
            subservice: finance.subservice,
        })
}

export const checkPayment = id => api.get(`check-payment/${id}`)
